import * as React from "react";
import { Menu, Icon, Image } from "semantic-ui-react";
import { Link, RouteComponentProps } from "react-router-dom";
import {withRouter} from "react-router";
import RestrictedRender from "../../../containers/RestrictedRender";
import entralpiLogo from "../../../assets/images/entralpi_logo.png";
import "../NavBar.css";
import "./DesktopTopNavBar.css";
import { WithTranslation, withTranslation } from 'react-i18next';
import { CommonUser } from "../../../types";
import { State } from "../../../reducers";
import { connect } from "react-redux";

interface DesktopTopNavBarProps extends WithTranslation, RouteComponentProps {
    handleLogOut: any;
    user: CommonUser;
}

const mapStateToProps = (state: State) => (
    {
      user: state.authentication.user,
    }
  );

class DesktopTopNavBar extends React.Component<DesktopTopNavBarProps> {
    adminItem = (currentPage: string) => {
        if (this.props.user && this.props.user.role && this.props.user.role.isAdmin)
            return (
                <Menu.Item className={currentPage === '/admin' ? 'selected' : ''}>
                    <RestrictedRender requiredRole="admin" />
                </Menu.Item>
            )
        return null;
    }

    private getDisplayedName(): string {
        if (!this.props.user) return String(this.props.t('navBar.profile') || 'Profile');
        
        const firstName = this.props.user.firstName;
        const lastName = this.props.user.lastName;
        if (lastName && firstName) {
            if (firstName.length <= 6) {
                return `${firstName} ${lastName[0]}.`
            }
            return `${firstName[0].toUpperCase()}. ${lastName[0].toUpperCase()}.`
        }
        // fallback
        return String(this.props.t('navBar.profile') || 'Profile');
    }

    private renderProfilePicture(): JSX.Element {
        if (!this.props.user) return <Icon name="user"/>;

        // Only show profile picture if it's not the default profile picture.
        if (this.props.user.imageUrl === "https://s3.us-east-2.amazonaws.com/entralpi/climb.jpg") {
            return <Icon name="user"/>;
        }
        return <Image className="profile-picture-preview" src={this.props.user.imageUrl} circular={true} />;
    }

    render() {
        const currentPage = this.props.location.pathname;
        const isAdmin = this.props.user && this.props.user.role && this.props.user.role.isAdmin;
        const menuItemNb = isAdmin ? 3 : 2;
        return (
            <div className='ui container desktopNavBar'>
                <Link className='entralpiLogo' to="/profile"><img src={entralpiLogo} alt={'logo'}/></Link>
                <Menu secondary fluid widths={menuItemNb}>

                    <Menu.Item className={currentPage === '/exercise-launcher' ? 'selected':''} as={Link} to="/exercise-launcher">
                        <p><Icon name="play" /> {String(this.props.t('navBar.exercise') || 'Exercise')}</p>
                    </Menu.Item>
                    <Menu.Item className={currentPage=='/profile' ?'selected':''} as={Link} to="/profile">
                        <p>{this.renderProfilePicture()}{String(this.getDisplayedName())}</p>
                    </Menu.Item>
                    {this.adminItem(currentPage)}
                </Menu>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation('common')(DesktopTopNavBar)));
